// @flow
import React from 'react';
import { ListFilterItem } from 'components/atoms/listFilterItem';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  options: Array,
  activeFilters: Array,
  toggleFilter: (option: any) => void,
};

export const CityFilter = (props: Props) => {
  const { options, activeFilters = [], toggleFilter } = props;
  return (
    <div className={'city-filters'}>
      <span className={'filter-type'}>CITY</span>
      <div className={'filter-content-options'}>
        {options.map(city => {
          return (
            <ListFilterItem
              key={city.cityId}
              title={city.city}
              isActive={activeFilters.indexOf(city.cityId) > -1}
              onClick={() => toggleFilter(city)}
            />
          );
        })}
      </div>
    </div>
  );
};
